import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
export var IconCardSquareGiant = function IconCardSquareGiant(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 58 54"
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 49.394,
    x: 57.5,
    y: 0.5,
    fill: "#F29A9A",
    stroke: "#47093A",
    rx: 3.5,
    transform: "rotate(90 57.5 .5)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36.946,
    height: 33.879,
    x: 38.484,
    y: 16.554,
    fill: "#fff",
    stroke: "#47093A",
    rx: 3.5,
    transform: "rotate(90 38.484 16.554)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#47093A",
    d: "M18.25 29.69a3.5 3.5 0 0 1 3.5 3.5V50a3.5 3.5 0 0 1-3.5 3.5H4A3.5 3.5 0 0 1 .5 50V33.19a3.5 3.5 0 0 1 3.5-3.5z"
  }));
};